<template>
  <div
    id="status-card"
    :style="style"
  >
    <div class="status-card-content">
      <slot/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StatusCard',
  props: {
    cor: {
      type: String,
      required: false,
      default: '#FFF00'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    style () {
      const backgroundColor = this.estilo.aplicacao.corPrimariaAplicacao + '0f'
      return {
        '--cor-situacao': this.cor,
        'background-color': this.disabled ? '#F6F6F6' : backgroundColor
      }
    }
  }
}
</script>

<style scoped>
#status-card {
  background-color: #EBF4FA;
  border-left: 5px solid var(--cor-situacao);
  width: 99%;
}
</style>
